import React from "react";
import { Badge } from "../../../shadcn/components/ui/badge";
import { TableCell, TableRow } from "../../../shadcn/components/ui/table";
import { useTranslation } from "../../../context/Internationalization";

// DS Manager has no success/warning colours: OK is secondary, waiting is outline, problems are destructive.
const STATUS_VARIANT = {
  requested: "outline",
  pending_dns: "outline",
  verifying: "outline",
  active: "secondary",
  failed: "destructive",
  expired: "destructive",
};

const STATUS_LABEL_KEY = {
  requested: "website_page_custom_domain_status_requested",
  pending_dns: "website_page_custom_domain_status_pending_dns",
  verifying: "website_page_custom_domain_status_verifying",
  active: "website_page_custom_domain_status_active",
  failed: "website_page_custom_domain_status_failed",
  expired: "website_page_custom_domain_status_expired",
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleString();
};

const ClubDomainRequestsTableRow = ({ request, lastElementRef }) => {
  const { t } = useTranslation();

  return (
    <TableRow ref={lastElementRef} key={request._id}>
      <TableCell className="px-4">
        <div className="text-sm">{request.clubName || request.clubId}</div>
        {request.clubSlug ? (
          <div className="text-xs text-muted-foreground">{request.clubSlug}</div>
        ) : null}
      </TableCell>
      <TableCell className="px-4 text-sm">{request.hostname}</TableCell>
      <TableCell className="px-4">
        <Badge variant={STATUS_VARIANT[request.status] || "outline"}>
          {t(STATUS_LABEL_KEY[request.status] || request.status)}
        </Badge>
      </TableCell>
      <TableCell className="px-4 text-sm">{formatDate(request.createdAt)}</TableCell>
    </TableRow>
  );
};

export default ClubDomainRequestsTableRow;
